export const environment = {
  production: true,
  appUrl: '/api/',
  hubUrl: '/hub',
  i18nUrl: '',
  baseUrl: '',
  appId: 'zERP',
  defaultPage: 'Home',
  windowsAuthentication: false,
  semanticVersion: '2.4.0.0'
};